import React from 'react';
import PropTypes from 'prop-types';

import { NotificationTarget } from '@teladoc/inbox';

const ActivityList = ({ notificationList, locales: { activityListTitle, emptyActivityTitle } }) => (
  <section className="preference-list-container">
    <header>
      <p>{activityListTitle}</p>
    </header>
    <section className="list-items">
      {!notificationList.length ? <p className="no-activity">{emptyActivityTitle}</p> :
      notificationList.map((item, index) => (
        <NotificationTarget
          key={index}
          index={index}
          item={item}
        />
        ))}
    </section>
  </section>
  );

ActivityList.propTypes = {
  notificationList: PropTypes.array,
  locales:          PropTypes.object
};

export default ActivityList;
